<mat-card *ngIf="xhrInProgress || dataSource" id="invoice-table">
  <mat-card-header>
    <mat-card-title>
      <h1>{{'invoices.title' | translate}}</h1>
    </mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <div class="spinner" *ngIf="xhrInProgress">
      <mat-progress-spinner color="primary" mode="indeterminate"></mat-progress-spinner>
    </div>
    <mat-table #table [dataSource]="dataSource" *ngIf="dataSource && !xhrInProgress">
      <ng-container matColumnDef="number">
        <mat-header-cell *matHeaderCellDef>{{'invoices.number' | translate}}</mat-header-cell>
        <mat-cell *matCellDef="let element">{{element.number}}</mat-cell>
      </ng-container>
      <ng-container matColumnDef="date">
        <mat-header-cell *matHeaderCellDef>{{'invoices.date' | translate}}</mat-header-cell>
        <mat-cell *matCellDef="let element">{{element.dueDate | date:'mediumDate':'':locale}}</mat-cell>
      </ng-container>
      <ng-container matColumnDef="amount">
        <mat-header-cell *matHeaderCellDef>{{'invoices.amount_due' | translate}}</mat-header-cell>
        <mat-cell *matCellDef="let element">{{element.amount | currency}}</mat-cell>
      </ng-container>
      <ng-container matColumnDef="paymentAmount">
        <mat-header-cell *matHeaderCellDef>{{'invoices.amount_paid' | translate}}</mat-header-cell>
        <mat-cell *matCellDef="let element">{{element.paymentAmount | currency}}</mat-cell>
      </ng-container>
      <ng-container matColumnDef="adjustments">
        <mat-header-cell *matHeaderCellDef>{{'invoices.adjustments' | translate}}</mat-header-cell>
        <mat-cell *matCellDef="let element">{{element.adjustmentsAmount | currency}}</mat-cell>
      </ng-container>
      <ng-container matColumnDef="tax" *ngIf="showTaxColumn">
        <mat-header-cell *matHeaderCellDef>{{'invoices.tax' | translate}}</mat-header-cell>
        <mat-cell *matCellDef="let element">{{element.taxAmount | currency}}</mat-cell>
      </ng-container>
      <ng-container matColumnDef="balance">
        <mat-header-cell *matHeaderCellDef>{{'invoices.balance' | translate}}</mat-header-cell>
        <mat-cell *matCellDef="let element">{{element.balance | currency}}</mat-cell>
      </ng-container>
      <ng-container matColumnDef="downloadUrl">
        <mat-header-cell *matHeaderCellDef></mat-header-cell>
        <mat-cell *matCellDef="let element">
          <pp-invoice-download-button [invoice]="element"></pp-invoice-download-button>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="mobile">
        <mat-cell *matCellDef="let element">
          <mat-expansion-panel #expansionPanel>
            <mat-expansion-panel-header collapsedHeight="auto" expandedHeight="auto">
              <mat-panel-title>
                <table>
                  <tbody>
                    <tr>
                      <td class="mat-column-number">{{element.number}}</td>
                      <td></td>
                    </tr>
                    <tr>
                      <td class="column-title column-date">{{'invoices.date' | translate}}</td>
                      <td class="column-data mat-column-date">{{element.dueDate | date:'mediumDate':'':locale}}</td>
                    </tr>
                    <tr>
                      <td class="column-title column-amount">{{'invoices.amount_due' | translate}}</td>
                      <td class="column-data mat-column-amount">{{element.amount | currency}}</td>
                    </tr>
                  </tbody>
                  <tbody *ngIf="expansionPanel.expanded">
                    <tr>
                      <td class="column-title column-paymentAmount">{{'invoices.amount_paid' | translate}}</td>
                      <td class="column-data mat-column-paymentAmount">{{element.paymentAmount | currency}}</td>
                    </tr>
                    <tr>
                      <td class="column-title column-adjustments">{{'invoices.adjustments' | translate}}</td>
                      <td class="column-data mat-column-adjustments">{{element.adjustmentsAmount | currency}}</td>
                    </tr>
                    <tr *ngIf="showTaxColumn">
                      <td class="column-title column-tax">{{'invoices.tax' | translate}}</td>
                      <td class="column-data mat-column-tax">{{element.taxAmount | currency}}</td>
                    </tr>
                    <tr>
                      <td class="column-title column-balance">{{'invoices.balance' | translate}}</td>
                      <td class="column-data mat-column-balance">{{element.balance | currency}}</td>
                    </tr>
                    <tr>
                      <td class="column-data mat-column-downloadUrl"><pp-invoice-download-button [invoice]="element"></pp-invoice-download-button></td>
                      <td></td>
                    </tr>
                  </tbody>
                </table>
              </mat-panel-title>
            </mat-expansion-panel-header>
          </mat-expansion-panel>
        </mat-cell>
      </ng-container>
      <mat-header-row *matHeaderRowDef="(isDesktop) ? columnsDesktop : []" [ngClass]="{'desktop': isDesktop, 'mobile-header': !isDesktop}"></mat-header-row>
      <mat-row *matRowDef="let row; columns: (isDesktop) ? columnsDesktop : columnsMobile;" [ngClass]="{'open-balance': row.balance > 0, 'desktop': isDesktop, 'mobile': !isDesktop}"></mat-row>
    </mat-table>
  </mat-card-content>
</mat-card>
